export const information = {
    location: '505 Realty St SW, Lenoir, NC 28645',
    locationUrl:
        'https://www.google.com/maps/place/Western+Carolina+Family+Dentistry/@35.901424,-81.539655,15z/data=!4m6!3m5!1s0x8850df16acec2b07:0x13bcb72c5f64dd1d!8m2!3d35.9052825!4d-81.5436251!16s%2Fg%2F11d_txklbc?hl=en&entry=ttu',
    phone: '(828) 754-2600',
    email: 'wcfdentistry@gmail.com',
};
